import { Padding } from '@mui/icons-material';

export const useTranscriptNoteStyles = () => ({
  root: {
    minWidth: '100%',
    backgroundColor: '#f7f6d4',
    '& .MuiAccordionSummary-root.Mui-expanded': {
      minHeight: '0px !important',
    },
    boxShadow:
      '0px 2px 1px -1px rgba(0, 0, 0, 0.1), 0px 1px 1px 0px rgba(0, 0, 0, 0.07), 0px 1px 3px 0px rgba(0, 0, 0, 0.06)',

    //'&.MuiAccordion-root.Mui-expanded': {
    //  backgroundColor: '#ffe0e0',
    //},
  },

  titleInput: {
    ml: 1,
    '& .MuiOutlinedInput-notchedOutline': {
      border: 'none',
    },
    '& .MuiInputBase-input': {
      fontSize: '0.8rem',
      fontWeight: 500,
      padding: 0,
    },
  },

  summaryContent: {
    flexGrow: 1,
    minWidth: 0,
    position: 'relative',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    height: '2rem',
  },

  summaryRoot: {
    //cursor: 'grab',
    padding: '0',
    minHeight: '0px !important',
    '& .MuiAccordionSummary-content': {
      margin: '0px !important',
    },
    '&.Mui-expanded': {
      backgroundColor: 'transparent',
    },
    '&:focus': {
      backgroundColor: 'transparent',
    },
  },

  detailsRoot: {
    padding: '0 .5rem',
  },

  descriptionInput: {
    '& .MuiOutlinedInput-notchedOutline': {
      border: 'none',
    },
    '& .MuiInputBase-root': {
      padding: '0 0 0.5rem 0',
    },
    '& .MuiInputBase-input': {
      fontSize: '0.8rem',
      padding: '0 0.25rem',
    },
  },

  dragIcon: {
    fontSize: '1.3rem',
    color: 'rgba(0, 0, 0, 0.54)',
    margin: 'auto',
    flexShrink: 0,
  },
  icon: {
    fontSize: '1.3rem',
  },
  deleteContainer: {
    borderTop: '0.0625rem solid grey',
    display: 'flex',
    justifyContent: 'flex-end',
  },
  button: {
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.04)',
    },
  },
});
